import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#988F88', // Button color
    },
    secondary: {
      main: '#807D79', // Accent color
    },
    background: {
      default: '#CABFB4', // Background color
      paper: '#CABFB4', // Card/paper background
    },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#CABFB4', // Header color
          color: '#000',
        },
      },
    },
  },
});

export default theme;